module.exports = __webpack_public_path__ + "static/dots-small-7fb6566be9e5a03094cdb956bb313801.svg";